import { lazyWithPreload } from "../utils/lazyWithPreload";

// The pages an upload moves on to. Each screen loads the next one while its own wait runs, so the route
// change shows the next banana bucket straight away instead of flashing the generic loader while the
// page's code downloads (slow on phones).
export const GenerateQuestionsPage = lazyWithPreload(() => import("./generate-questions-page/GenerateQuestionsPage"));
export const PreviewOfMiniLessonPage = lazyWithPreload(
  () => import("./review-deck-page/first-user-experience/PreviewOfMiniLessonPage")
);

/** Starts loading a page ahead of its route. A failure is ignored here; the route retries when it renders. */
export function preloadPage(page: { preload: () => Promise<unknown> }) {
  page.preload().catch(() => undefined);
}
